import AddBoxIcon from "@mui/icons-material/AddBox";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import { Grid, Typography } from "@mui/material";
import { useState } from "react";

// Fonction récursive pour afficher un JSON avec possibilité de "collapse"
const JsonViewer = ({ label, data, level = 0, defaultOpen = 0 }) => {
  const width = 20;
  const [open, setOpen] = useState(defaultOpen > 0);

  const handleToggle = () => {
    setOpen(!open);
  };

  const stringify = (value) => {
    if (typeof value === "function") {
      return <i>function</i>;
    }
    return JSON.stringify(value);
  };

  const renderValue = (key, value, level) => {
    if (typeof value === "object" && value !== null) {
      return (
        <JsonViewer
          key={key}
          label={key}
          data={value}
          level={level}
          defaultOpen={defaultOpen - 1}
        />
      );
    } else {
      return (
        <Grid key={key} container size={12} alignItems={"center"}>
          <Grid sx={{ width: width * 2 }} />
          <Grid sx={{ width: width * level }} />
          <Grid size="grow">
            <Typography component="span" variant="body1" sx={{ fw: 900 }}>
              {key} :
            </Typography>
            <Typography component="span" variant="body1" ml={1}>
              {stringify(value)}
            </Typography>
          </Grid>
        </Grid>
      );
    }
  };

  const [openC, closeC] = Array.isArray(data) ? ["[", "]"] : ["{", "}"];

  if (typeof data !== "object" || data === null || data === undefined) {
    return (
      <Grid container size={12} alignItems={"center"}>
        <Grid sx={{ width: width * 2 }} />
        <Grid sx={{ width: width * level }} />
        <Grid size="grow">
          <Typography component="span" variant="body1" sx={{ fw: 900 }}>
            {label} :
          </Typography>
          <Typography component="span" variant="body1" ml={1}>
            {stringify(data)}
          </Typography>
        </Grid>
      </Grid>
    );
  }

  if (!open) {
    return (
      <Grid container size={12} alignItems={"center"}>
        <Grid sx={{ width: width * 2 }}>
          <AddBoxIcon sx={{ scale: 0.7 }} onClick={handleToggle} />
        </Grid>
        <Grid sx={{ width: width * level }} />
        <Grid
          size="grow"
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            textWrap: "nowrap",
          }}
        >
          <Typography component="span" variant="body1" sx={{ fw: 900 }}>
            {label} :
          </Typography>
          <Typography component="span" variant="body1" ml={1}>
            {openC}
            {"..."}
            {closeC}
          </Typography>
          <Typography
            component="span"
            variant="caption"
            ml={1}
            sx={{ fontStyle: "italic", opacity: 0.7 }}
          >
            // {JSON.stringify(data)}
          </Typography>
        </Grid>
      </Grid>
    );
  }

  if (open) {
    return (
      <>
        <Grid container size={12} alignItems={"center"}>
          <Grid sx={{ width: width * 2 }}>
            <IndeterminateCheckBoxIcon
              sx={{ scale: 0.7 }}
              onClick={handleToggle}
            />
          </Grid>
          <Grid sx={{ width: width * level }} />
          <Grid size="grow">
            <Typography component="span" variant="body1" sx={{ fw: 900 }}>
              {label} :
            </Typography>
            <Typography component="span" variant="body1" ml={1}>
              {openC}
            </Typography>
          </Grid>
        </Grid>
        {Object.keys(data).map((key) => renderValue(key, data[key], level + 1))}
        <Grid container size={12} alignItems={"center"}>
          <Grid sx={{ width: width * 2 }} />
          <Grid sx={{ width: width * level }} />
          <Grid size="grow">
            <Typography component="span" variant="body1">
              {closeC}
            </Typography>
          </Grid>
        </Grid>
      </>
    );
  }
};

export default JsonViewer;
